/**
 * @desc 通过管理域获取分厂信息(不包含部门)
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {
  /** 组织编码 */
  orgCode?: string;
}

export function request(
  params: Params,
): Promise<defs.StandardReturn<defs.QueryBaseInfoListResponse>> {
  return defHttp.get({
    url: '/web/base/factoryByOrgCode',

    params,
  });
}

export function mock(
  params: Params,
): Promise<defs.StandardReturn<defs.QueryBaseInfoListResponse>> {
  return defHttp.get({
    url: '/mock/web/base/factoryByOrgCode',

    params,
  });
}
